import { createFileRoute } from '@tanstack/react-router';

import { RoutePlaceholder } from '@/components/app/RoutePlaceholder';

export const Route = createFileRoute('/find-and-fix/poi/$poiId/')({
    component: PoiIndex,
});

function PoiIndex() {
    const { poiId } = Route.useParams();
    return <RoutePlaceholder title={`Find & Fix — POI ${poiId}`} />;
}
